import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "small-label"
}, "Дата создания", -1)
const _hoisted_3 = { class: "flex flex-col m-t-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Бренд", -1)
const _hoisted_5 = { class: "flex flex-col m-t-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Магазин", -1)
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex flex-col m-t-8 m-r-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "period",
  class: "small-label"
}, "Дата начала", -1)
const _hoisted_10 = { class: "flex flex-col m-t-8" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "period",
  class: "small-label"
}, "Дата окончания", -1)
const _hoisted_12 = { class: "flex flex-col m-t-8" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "segmentMame",
  class: "small-label"
}, "Наименование РК", -1)
const _hoisted_14 = { class: "flex flex-col m-t-8" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Статус РК", -1)
const _hoisted_16 = { class: "flex flex-col m-t-8" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Пользователь", -1)
const _hoisted_18 = { class: "flex flex-col m-t-8" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Сегмент", -1)
const _hoisted_20 = { class: "flex flex-col m-t-8" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Рекламная площадка отправленного сегмента", -1)
const _hoisted_22 = { class: "flex flex-col m-t-8" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Источник кампании", -1)
const _hoisted_24 = { class: "flex flex-col m-t-8" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Кабинет сегмента", -1)
const _hoisted_26 = { class: "flex m-t-18 m-b-8 fl-jc-sb" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "updated" }, "Обновляемый сегмент", -1)

import InputText from "primevue/inputtext";
import Calendar from "primevue/calendar";
import MultiSelect from "primevue/multiselect";
import InputSwitch from "primevue/inputswitch";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";

import { useCampaignsDictionariesStore } from "@/store/dictionaries/campaigns";


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignsFilterForm',
  props: {
    isFilterEnabled: { type: Boolean }
  },
  emits: ["toggleFilter", "setFilter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const campaignsDictionariesStore = useCampaignsDictionariesStore();

const initialFilter = {
  name: "",
  date: null,
  period: {
    start: null,
    end: null,
  },
  state: [] as number[],
  type: [] as number[],
  user: [] as number[],
  platform: [] as string[],
  platform_cabinet: [] as string[],
  ads_cabinet: [] as number[],
  segment: [] as number[],
  brand: [] as string[],
  shop: [] as number[],
  updated: false,
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListFilterForm, {
    "is-filter-enabled": props.isFilterEnabled,
    "initial-filter": initialFilter,
    onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleFilter'))),
    onSetFilter: setParentFilter
  }, {
    fields: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(Calendar), {
          id: "date",
          panelClass: "not-extended",
          placeholder: "Выберите значение",
          modelValue: slotProps.filter.date,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.date) = $event),
          "aria-describedby": "date-help",
          showIcon: "",
          iconDisplay: "input",
          inputId: "icondisplay"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "brand",
          isSegmentSetted: false,
          modelValue: slotProps.filter.brand,
          "onUpdate:modelValue": ($event) => (slotProps.filter.brand = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "shop",
          isSegmentSetted: false,
          modelValue: slotProps.filter.shop,
          "onUpdate:modelValue": ($event) => (slotProps.filter.shop = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_unref(Calendar), {
            id: "date",
            placeholder: "Дата",
            modelValue: slotProps.filter.period.start,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.period.start) = $event),
            "aria-describedby": "date-help",
            showIcon: "",
            iconDisplay: "input",
            inputId: "icondisplay"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_unref(Calendar), {
            id: "date",
            placeholder: "Дата",
            modelValue: slotProps.filter.period.end,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.period.end) = $event),
            "aria-describedby": "date-help",
            showIcon: "",
            iconDisplay: "input",
            inputId: "icondisplay"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_unref(InputText), {
          id: "segmentMame",
          placeholder: "Введите название",
          modelValue: slotProps.filter.name,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.name) = $event),
          "aria-describedby": "username-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_unref(MultiSelect), {
          modelValue: slotProps.filter.state,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.state) = $event),
          optionValue: "name",
          options: _unref(campaignsDictionariesStore).statesAllowed,
          optionLabel: "display_name",
          placeholder: "Выберите значение"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "user",
          isSegmentSetted: false,
          modelValue: slotProps.filter.user,
          "onUpdate:modelValue": ($event) => (slotProps.filter.user = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "segment",
          isSegmentSetted: false,
          modelValue: slotProps.filter.segment,
          "onUpdate:modelValue": ($event) => (slotProps.filter.segment = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode(CatalogDataBaseInput, {
          "not-search": true,
          useIdOnly: true,
          selectType: "platform",
          isSegmentSetted: false,
          modelValue: slotProps.filter.platform,
          "onUpdate:modelValue": ($event) => (slotProps.filter.platform = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode(CatalogDataBaseInput, {
          "not-search": true,
          useIdOnly: true,
          selectType: "source",
          isSegmentSetted: false,
          modelValue: slotProps.filter.platform_cabinet,
          "onUpdate:modelValue": 
            ($event) => (slotProps.filter.platform_cabinet = $event)
          
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "ads_cabinet",
          isSegmentSetted: false,
          modelValue: slotProps.filter.ads_cabinet,
          "onUpdate:modelValue": 
            ($event) => (slotProps.filter.ads_cabinet = $event)
          
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createVNode(_unref(InputSwitch), {
          modelValue: slotProps.filter.updated,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.updated) = $event),
          inputId: "updated"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["is-filter-enabled"]))
}
}

})